const n = /^[A-Za-z0-9_-]{1,128}$/;
class o extends Error {
  identifier;
  kind;
  constructor(e, i, t) {
    super(
      `Invalid ${i} identifier ${JSON.stringify(e)}: ${t}`
    ), this.name = "InvalidIdentifierError", this.identifier = e, this.kind = i;
  }
}
function s(r) {
  return typeof r == "string" && n.test(r);
}
function d(r, e) {
  if (!s(r))
    throw new o(
      String(r),
      e,
      "expected 1-128 characters of letters, digits, underscore or hyphen"
    );
  return r;
}
function f(r, e) {
  return `"${d(r, e).replace(/"/g, '""')}"`;
}
function c(r, e) {
  return r.map((i) => f(i, e)).join(".");
}
function a(r) {
  return `'${r.replace(/'/g, "''")}'`;
}
export {
  o as InvalidIdentifierError,
  d as assertValidIdentifier,
  s as isValidIdentifier,
  f as quoteIdentifier,
  c as quoteQualifiedName,
  a as quoteStringLiteral
};
